import React, {useState, useRef} from "react";
import "./contact.styles.scss";
import axios from 'axios';
import Recaptcha from "react-recaptcha"


const Contact = () => {
    const [formItems, setFormItems] = useState(
      {name: "", 
      email: "", 
      phone: "", 
      message: ""
    });

    const [messageSent, setMessageSent] = useState(false);
    const [showCaptcha, setShowCaptcha] = useState(false);
    const [btnDisabled, setBtnDisabled] = useState(false);
    const [validationMessage, setValidationMessage] = useState([]);



    const handleInput = (e) => {
        const {value, name} = e.target;
        setFormItems({
            ...formItems,
            [name]: value
        });
    };

    const resetCapture = useRef()
    const handleCaptcha = () => {
      console.log('captcha')
    }

    const verifyCallback = async (response) => {
        if (response) {
            submitForm()
        }
    }

    const handleShowCaptcha = () => {
        if (validationCheck() === true) {
            

          setBtnDisabled(true)
          setShowCaptcha(true);  
        } else {
          let validationArray = validationCheck();
          let validationMessageArray = []
          validationArray.forEach(item => {
            if (Object.keys(item)[0] === 'name') {
              validationMessageArray = [...validationMessageArray, 'Name is required']
            } 
            if (Object.keys(item)[0] === 'email') {
              validationMessageArray = [...validationMessageArray, 'You must enter a valid email address']
            } 
            if (Object.keys(item)[0] === 'message') {
              validationMessageArray = [...validationMessageArray, 'A message is required']
            } 

          })

      

          setValidationMessage(validationMessageArray)
          setTimeout(() => {
            setValidationMessage([])
          }, 3000)
        }
       

         
    }

    const validateEmail = (email) => {
      // eslint-disable-next-line no-useless-escape
      const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(email).toLowerCase());
    }

    const validationCheck = () => {
   
      const array = ['name', 'email', 'message']
      if (!formItems.name) {
        array[0] = { name: false }
      } else {
        array[0] = { name: true }
      }

      if (!formItems.message) {
        array[2] = { message: false }
      } else {
        array[2] = { message: true }
      }

      if (!validateEmail(formItems.email)) {
        array[1] = {email: false}
      } else {
        array[1] = {email: true}
      }

      // eslint-disable-next-line array-callback-return
      const falseArray = array.filter(item => {
        if (Object.values(item)[0] === false) {
          return item;
        }
        
        
      })

      if (falseArray.length > 0) {
        return falseArray;
      } else {
        return true;
      }
    
    }

    const submitForm = async () => {
   
            const body = {
                formItems
            }

            axios.post('https://gsjb7ndw07.execute-api.eu-west-1.amazonaws.com/dev/email', body).then(() => {
                setMessageSent(true);
                resetCapture.current.reset();
                setShowCaptcha(false);
                
                setFormItems({name: "", email: "", phone: "", message: ""});
                setTimeout(() => {
                    setMessageSent(false);
                    setBtnDisabled(false)
                }, 3000);
            }).catch(err => {
                console.log('ERR', err)
                resetCapture.current.reset();
                setShowCaptcha(false);
                setBtnDisabled(false)

            })
        

    }
    return (
        <>
        <div className="contact-container" id="contact">
            <div className="inner-contact-container" >
                <h2>SAY HI</h2>
                <div className="form">
                    <input 
                      name="name" 
                      placeholder="* NAME"
                      value={formItems.name}
                      onChange={handleInput}
                      >
                    </input>
                    <input 
                      name="email" 
                      placeholder="* EMAIL"
                      value={formItems.email}
                      onChange={handleInput}
                      >
                    </input>
                    <input 
                      name="phone" 
                      placeholder=" PHONE"
                      value={formItems.phone}
                      onChange={handleInput}> 
                    </input>
                    <textarea 
                      name="message" 
                      placeholder="* WRITE YOUR MESSAGE HERE..."
                      value={formItems.message}
                      onChange={handleInput}
                      >

                    </textarea>
                    <div className="send-area">
                            { validationMessage.length === 0 
                            && !messageSent 
                            && <div>

                            </div>
                            }
                            {
                            messageSent && 
                            <div className="thanks">
                              <p>Hey, I got your message. I'll be in touch!</p>
                            </div>
                            }    
                         
                         
                            { 
                            validationMessage.length > 0 && 
                            <div className="error">
                              {
                           
                            validationMessage.map(item => {
                              return (
                              
                                  <ul key={item} >
                                    <li>{item}</li>
                                  </ul>
                                  
                                )
                              })
                            }
                              </div>
                              }
                             
                        <button 
                        
                          onClick={handleShowCaptcha}
                          disabled={btnDisabled}
                          className={btnDisabled ? 'btn-disabled' : ''}
                        >SEND</button>
                    </div>
                </div>
               
                {
                showCaptcha && 
                <div className="recaptcha">
                    <Recaptcha sitekey="6LfNSsIZAAAAAAXO3wL8r-0A2oYxpkT-mQxhz2Ul" render="explicit"
                        onloadCallback={handleCaptcha}
                        verifyCallback={verifyCallback}
                        ref={resetCapture}
                       />
                </div>
               
            } 
              
                
               
       
           
            
            </div>
        </div>
        </>
    );
    
};

export default Contact;
